import {
  CLEAR_ALL,
  GETALL_EVENTOS,
  LOADING_GETALL_EVENTOS,
  PARAMS_EVENTOS,
  SET_ACTIVO_EVENTOS,
  SET_LOGOUT,
  SLOTINFO_EVENTOS,
} from '../../../store/Types';

const initialState = {
  all: [],
  meta: null,
  links: null,
  activo: null,
  params: {},
  loadingGetAll: false,
};

export const eventosReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETALL_EVENTOS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case SET_ACTIVO_EVENTOS:
      return {
        ...state,
        activo: action.payload,
      };
    case SET_LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    case LOADING_GETALL_EVENTOS:
      return {
        ...state,
        loadingGetAll: action.payload,
      };
    case PARAMS_EVENTOS:
      return {
        ...state,
        params: action.payload,
      };
    case SLOTINFO_EVENTOS:
      return {
        ...state,
        slotInfo: action.payload,
      };
    default:
      return state;
  }
};
